export default __webpack_public_path__ + "static/media/sidebar-home.ad0ec7ba.svg";